<div class="container-fluid">
  <div class="d-flex justify-content-between align-items-center my-3">
    <h3>{{ 'CROSS_REFERENCES' | translate }}</h3>
    <div>
      <button type="button" class="btn btn-secondary mr-2" (click)="export()" [disabled]="exporting">
        {{ 'EXPORT_EXCEL' | translate }}
      </button>
      <button
        type="button"
        class="btn btn-secondary mr-2"
        (click)="fileInput.click()"
        [disabled]="importing"
      >
        {{ 'IMPORT_EXCEL' | translate }}
      </button>
      <input #fileInput type="file" accept=".xlsx" class="d-none" (change)="onFileSelected(fileInput)" />
      <button type="button" class="btn btn-primary" (click)="add()">{{ 'ADD_CROSS_REFERENCE' | translate }}</button>
    </div>
  </div>
  @if (importReport) {
    <div class="alert mt-2" [class.alert-success]="importReport.applied" [class.alert-danger]="!importReport.applied">
      @if (importReport.applied) {
        <span>{{ 'IMPORT_APPLIED' | translate }}</span
        >: {{ importReport.inserted }} <span>{{ 'INSERTED' | translate }}</span
        >, {{ importReport.updated }} <span>{{ 'UPDATED' | translate }}</span>
      } @else {
        <div><span>{{ 'IMPORT_REJECTED' | translate }}</span></div>
        <ul class="mb-0">
          @for (error of importReport.errors; track error) {
            <li>{{ error | translate }}</li>
          }
        </ul>
      }
    </div>
  }
  <div class="row font-weight-bold border-bottom pb-1 d-none d-md-flex">
    <div class="col-2">{{ 'CROSS_BRAND' | translate }}</div>
    <div class="col-3">{{ 'CROSS_REFERENCE' | translate }}</div>
    <div class="col-3">{{ 'OTTO_PRODUCT_ID' | translate }}</div>
    <div class="col-2">{{ 'NOTE' | translate }}</div>
    <div class="col-2"></div>
  </div>
  <lib-filter-list [configService]="listConfig"></lib-filter-list>
</div>
